import React from "react"

import "./src/styles/global.css"
import CookieConsent from "./src/components/cookieConsent/CookieConsent"

// Mount the cookie banner once at the root so it survives client-side
// navigation. Mounting it inside Layout remounts it on every <Link>, which
// would kill the banner and the settings button after the first navigation.
export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <CookieConsent />
  </>
)
